/**
 * Do not edit directly
 */

export default "PHN2ZyB3aWR0aD0iMTciIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNyAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB4PSIzIiB5PSIyLjUiIHdpZHRoPSIxMSIgaGVpZ2h0PSIxMSIgc3Ryb2tlPSJibGFjayIvPjwvc3ZnPg==";